import api from "./axios";

export default class ProductService {
  addProduct = (productId: number) => {
    return api.post("/api/ems/add-product", { productId });
  };

  removeProduct = (productId: number) => {
    return api.post("/api/ems/remove-product", {
      productId: productId,
    });
  };

  getAddons = () => {
    return api.get("/api/web-api/public/shop/options/get-options");
  };

  getProducts = (
    subscriptionId: string,
    compatibleId: string,
    facilityId: string
  ) => {
    return api.get("/api/ems/get-products", {
      params: {
        subscriptionId,
        compatibleId,
        facility: facilityId,
        categories: "additional",
        statuses: "Published",
      },
    });
  };
}
